import React from 'react';
import PropTypes from 'prop-types';

const DownloadLink = ({ link }) =>
  <a className="resource-download" href={link} download target="_blank" rel="noopener noreferrer">
    Download assets
    <i className="icon icon-budicon-461" aria-hidden="true" />
  </a>;

DownloadLink.propTypes = {
  link: PropTypes.string.isRequired
};

export default DownloadLink;



// WEBPACK FOOTER //
// ./src/pages/press/components/DownloadLink/DownloadLink.js